import { createGlobalStyle } from 'styled-components';

export const theme = {
  colors: {
    navy: '#1B3A4B',
    navyDark: '#142d3b',
    skyBlue: '#29B6E8',
    orange: '#F5882A',
    white: '#FFFFFF',
    lightGray: '#F4F6F8',
    darkGray: '#5D6D7E',

    // Aliases for compatibility
    gold: '#F5882A',
    gray50: '#F4F6F8',
    gray100: '#e8ecef',
    gray200: '#d1d9e0',
    gray300: '#b0bec5',
    gray400: '#90a4ae',
    gray500: '#78909c',
    gray600: '#5D6D7E',
    gray700: '#455a64',

    success: '#27ae60',
    error: '#e74c3c',
  },

  fonts: {
    sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
    serif: "'DM Serif Display', Georgia, serif",
  },

  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    '2xl': '24px',
    full: '9999px',
  },

  shadows: {
    sm: '0 1px 3px rgba(0,0,0,0.08)',
    md: '0 4px 12px rgba(0,0,0,0.1)',
    lg: '0 10px 30px rgba(0,0,0,0.12)',
    xl: '0 20px 40px rgba(0,0,0,0.15)',
  },
};

const GlobalStyles = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
    font-size: 16px;
  }

  body {
    font-family: ${props => props.theme.fonts.sans};
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.darkGray};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.serif};
    font-weight: 400;
    line-height: 1.2;
    color: ${props => props.theme.colors.navy};
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    font-family: ${props => props.theme.fonts.sans};
    cursor: pointer;
    border: none;
    background: none;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.lightGray};
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.gray300};
    border-radius: 4px;
  }

  ::selection {
    background: ${props => props.theme.colors.orange};
    color: ${props => props.theme.colors.white};
  }

  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(24px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export default GlobalStyles;
